module.exports = __webpack_public_path__ + "img/Ford_logo_300x300.467ddc83.png";